module.exports = __webpack_public_path__ + "img/portraits_06_V.7de70025.webp";